import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 20268 19867"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#1c1b17;stroke-width:224.678}.fil0{fill:#000}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974598863664">
        <path
          d="M19593 12820c-278 2899-2804 4916-5280 6128 1297-2516 176-5987-2563-7019 351-376 594-849 691-1356 1890-115 7463-656 7152 2247zm-9224 2008c-100 1534-826 3049-2068 3997l5-5c-167 126-346 238-537 324 2-1 3-2 7-3-123 50-250 89-382 110 2 0 4 0 4 1-13 0-52 7-18 0-143 18-292 10-430-5-1129-202-2187-718-3096-1402 2 2 2 2 5 4-8-6-15-11-23-17 6 5 12 9 18 13-27-21-31-23-26-19-506-377-1143-1036-1437-1422-468-603-861-1269-1137-1977 2458-97 5264-615 6904-2593 478 575 1230 610 1903 763 262 712 358 1477 308 2231zm-4796-4459c-213 47-427 87-643 117-8376 196-2999-8964 2293-9624-1817 2127-1213 5960 1214 7414-429 392-734 907-844 1470-663 241-1330 471-2020 623zm4613-3689c171-1558 593-3177 1387-4540 272-347 658-587 1061-761 2931-1220 6253 1460 6646 4479-2464-2379-6730-466-7923 2356-350-259-718-539-1156-628-29-301-32-604-15-906zm1030-3913c10-22-1 3-6 14 2-4 4-9 6-14zm362-633c30-40 2 1-5 6 2-2 4-4 5-6zm8478 9635c-1502-2355-5128-1818-7575-1733-18-443-170-887-469-1223 248-404 799-922 1068-1123 1355-1123 3521-1297 4987-633 535 24 1767 1551 1921 746 51-2022-543-4150-2008-5617-4937-4193-8611 99-8311 5402-14 3-28 6-43 9-2432-1608-1707-4919-665-7151-598-1206-5363 1177-6138 2048-5258 4211-2371 10639 4336 7969-4290 3948-7759 157-6724 3155 707 3058 3924 6425 7353 6086 2608-1125 3692-4505 2844-7077 22-3 44-6 66-11 66 52 126 110 189 165 259 356 735 616 986 1033l-5-5c1122 1457 2064 3707 861 5367-165 147-305 402-64 553 3181 440 8284-4626 7391-7960z"
          className="fill stroke1"
          style={{
            strokeWidth: 224.678,
          }}
        />
        <path
          d="M11179 11764c2-4 3-6 4-7-36 32-59 57-70 73 22-23 44-44 66-66zM8819 11425c6 16 12 25 17 37-5-18-13-37-23-56 3 6 4 14 6 19zM8670 10834c1 10 1 17 2 27 5 23 10 47 13 72 13 32 23 13-15-99z"
          className="fill stroke1"
          style={{
            strokeWidth: 224.678,
          }}
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
